import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { api } from "../lib/api";
import { ArrowLeft } from "lucide-react";

export function BlogList() {
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data));
  }, []);
  return (
    <main className="max-w-7xl mx-auto px-6 md:px-8 py-14 md:py-20" data-testid="blog-page">
      <span className="eyebrow">À lire</span>
      <h1 className="font-heading mt-4 text-[var(--agt-navy)] mb-16" style={{ fontSize: "clamp(2.5rem, 6vw, 4.5rem)" }}>
        Le <span className="font-heading-accent text-[var(--agt-mustard-deep)]">blog.</span>
      </h1>
      <div className="grid md:grid-cols-3 gap-8">
        {posts.map((p, i) => (
          <motion.div key={p.id} initial={{ opacity: 0, y: 25 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.06 }}>
            <Link to={`/blog/${p.slug}`} className="card-soft group block" data-testid={`blog-item-${p.slug}`}>
              {p.cover_image && (
                <div className="overflow-hidden rounded-t-[24px]">
                  <img src={p.cover_image} alt={p.title} className="aspect-[4/3] w-full object-cover group-hover:scale-105 transition-transform duration-500"/>
                </div>
              )}
              <div className="p-7">
                <span className="eyebrow-navy text-[0.65rem]">Article</span>
                <h3 className="font-heading text-2xl mt-3 leading-tight text-[var(--agt-navy)] group-hover:text-[var(--agt-mustard-deep)] transition-colors">{p.title}</h3>
                <p className="mt-3 text-base text-[var(--agt-ink-muted)] leading-relaxed">{p.excerpt}</p>
                <p className="mt-4 text-xs uppercase tracking-widest text-[var(--agt-ink-muted)] font-bold">Par {p.author}</p>
              </div>
            </Link>
          </motion.div>
        ))}
        {posts.length === 0 && <p className="text-[var(--agt-ink-muted)] col-span-3">Aucun article pour le moment.</p>}
      </div>
    </main>
  );
}

export function BlogDetail() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  useEffect(() => {
    api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setPost(false));
  }, [slug]);

  if (post === false) return <main className="max-w-3xl mx-auto p-10 text-center text-[var(--agt-ink-muted)]">Article introuvable</main>;
  if (!post) return <main className="max-w-3xl mx-auto p-10">Chargement…</main>;

  return (
    <main className="max-w-3xl mx-auto px-6 md:px-8 py-14 md:py-20" data-testid="blog-detail">
      <Link to="/blog" className="inline-flex items-center gap-1 text-sm font-bold text-[var(--agt-mustard-deep)] mb-8 hover:text-[var(--agt-navy)]"><ArrowLeft className="w-4 h-4"/> Retour au blog</Link>
      {post.cover_image && <img src={post.cover_image} alt={post.title} className="w-full aspect-[16/9] object-cover rounded-3xl mb-10 shadow-xl"/>}
      <span className="eyebrow-navy">Article</span>
      <h1 className="font-heading mt-4 leading-tight text-[var(--agt-navy)]" style={{ fontSize: "clamp(2.4rem, 5vw, 4rem)" }}>{post.title}</h1>
      <p className="mt-6 text-xs uppercase tracking-widest text-[var(--agt-ink-muted)] font-bold">Par {post.author}</p>
      <div className="mt-10 text-lg text-[var(--agt-navy)] leading-relaxed whitespace-pre-line">{post.content}</div>
    </main>
  );
}
